import { ReactElement, useContext } from 'react';
import { AdminContext } from '../../../../modules/admin/AdminContext';
import { AdminWorkspacesListContainer } from '../../../../modules/admin/containers/AdminWorkspacesList.container';

export const WorkspacesView = (): ReactElement => {
  const adminContext = useContext(AdminContext);
  return <AdminWorkspacesListContainer search={adminContext.search} />;
};
